import { render, staticRenderFns } from "./ProduksiShearing.vue?vue&type=template&id=ed543422&scoped=true&"
import script from "./ProduksiShearing.vue?vue&type=script&lang=js&"
export * from "./ProduksiShearing.vue?vue&type=script&lang=js&"
import style0 from "./ProduksiShearing.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProduksiShearing.vue?vue&type=style&index=1&id=ed543422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed543422",
  null
  
)

export default component.exports